// extracted by mini-css-extract-plugin
module.exports = {"avatarimage":"avatar_image_avatarimage__2kDVx"};